import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
import cn from "classnames";
export default function Problem({
  descriptionOne,
  descriptionTwo,
  descriptionThree,
  points,
  image,
  title,
  reverse = false,
  className = "bg-[#F4F9FF]",
  id,
}) {
  return (
    <Section className={className} id={id}>
      <div
        className={cn("flex lg:gap-12 gap-6 w-full mx-auto", {
          "lg:flex-row-reverse flex-col-reverse items-center": reverse,
          "lg:flex-row flex-col-reverse items-center": !reverse,
        })}
      >
        <div className="flex flex-col gap-3">
          <h2 className="text-darkBlue">{title ?? "The Problem"}</h2>
          {descriptionOne && (
            <div
              className="text-body md:text-base text-sm text-justify"
              dangerouslySetInnerHTML={{ __html: descriptionOne }}
            />
          )}
          {descriptionTwo && (
            <div
              className="text-body md:text-base text-sm text-justify"
              dangerouslySetInnerHTML={{ __html: descriptionTwo }}
            />
          )}
          {descriptionThree && (
            <div
              className="text-body md:text-base text-sm text-justify"
              dangerouslySetInnerHTML={{ __html: descriptionThree }}
            />
          )}
        </div>
        <div className="relative lg:w-[400px] lg:h-[400px] md:w-full md:h-[250px] w-full h-[200px] shrink-0 rounded-2xl overflow-hidden">
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover object-left w-full rounded-2xl"
            sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px "
          />
        </div>
      </div>
      {points && (
        <div className="grid lg:grid-cols-3 grid-cols-1 w-full gap-6 lg:mt-10 mt-8">
          {points?.map((point, key) => (
            <HeaderIconBox key={"iconBox" + key} data={point} />
          ))}
        </div>
      )}
    </Section>
  );
}
const HeaderIconBox = ({ data }) => {
  const { description, heading, icon } = data;
  return (
    <div className="w-full flex flex-col justify-start items-center gap-4 p-4 rounded-2xl bg-white group hover:bg-white hover:shadow-artist border-[1px] border-white hover:border-darkBlue transition-all duration-300 ease">
      <div className="lg:h-24 h-20 lg:w-24 w-20 rounded-2xl flex flex-col shrink-0 justify-center items-center bg-[#F4F9FF] transition-all duration-300 ease relative">
        <Image
          src={icon}
          alt={"icon"}
          fill
          className="object-contain object-center w-full p-5"
          sizes="(max-width: 479px) 200px,(max-width: 768px) 200px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px "
        />
      </div>
      <div className="flex flex-col w-full gap-2">
        <p className="lg:text-lg text-base text-darkBlue font-bold text-center">
          {heading}
        </p>
        <div
          className="lg:text-base text-sm text-body mb-0 text-justify"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};
